module.exports = __webpack_public_path__ + "93ad08ac2445c26e9a1fc1f0fcc2b992.svg";